import { render, staticRenderFns } from "./SimpleTab.vue?vue&type=template&id=4ae597bc&scoped=true"
import script from "./SimpleTab.vue?vue&type=script&lang=js"
export * from "./SimpleTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae597bc",
  null
  
)

export default component.exports